import React from 'react';
import { TextButton } from 'js/design_system/TextButton';
import { currentUser } from 'js/utils/user';

interface DebugToggleButtonProps {
  page: 'triage' | 'debug' | 'overview';
  onToggle: (newPage: 'triage' | 'debug') => void;
  style?: React.CSSProperties;
}

export const DebugToggleButton: React.FC<DebugToggleButtonProps> = ({
  page,
  onToggle,
  style,
}) => {
  if (!currentUser?.admin) {
    return null;
  }

  const handleClick = () => {
    if (page === 'debug') {
      onToggle('triage');
    } else {
      onToggle('debug');
    }
  };

  return (
    <TextButton onClick={handleClick} style={style}>
      {page === 'debug' ? 'Triage' : 'Debug'}
    </TextButton>
  );
};
